import PropTypes from "prop-types";
import { PAYMENT_METHODS, PAYMENT_TERMS } from "app/constants";
import "./PaymentMethodsFieldsetNew.scss";
import PaymentTypeInput from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/PaymentTypeInput";
import CreditCardPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/creditCard/CreditCardPaymentType";
import { paymentTypeShape } from "app/utils/propTypes";

const PaymentMethodsFieldsetNew = ({
	onChange,
	allowedPaymentTypes = [],
	ideal = {},
	onCreditCardInputsBlur,
	onAdyenComponentMounted,
	onCreditCardSubmit,
	onAdyenAdditionalDetails,
	total,
	mensualite2Fois = {},
	swissbilling = { forbiddenCause: "", cgvURL: "" },
}) => {
	if (allowedPaymentTypes.length > 1) {
		return (
			<div className="payment-methods-fieldset-new">
				<div>
					{allowedPaymentTypes.map(allowedPaymentType => {
						if (
							!Object.values(PAYMENT_METHODS).includes(allowedPaymentType.paymentType)
						) {
							return false;
						}

						let isAdyenFlow;

						if (allowedPaymentType.paymentType === PAYMENT_METHODS.ADYEN_FLOW) {
							isAdyenFlow = true;
						} else if (allowedPaymentType.paymentType === PAYMENT_METHODS.CARD) {
							isAdyenFlow = false;
						}

						return (
							<div
								className="payment-methods-fieldset-new__item"
								key={allowedPaymentType.paymentType + allowedPaymentType.terms}
							>
								<PaymentTypeInput
									swissbilling={swissbilling}
									total={total}
									isAdyenFlow={isAdyenFlow}
									mensualite2Fois={mensualite2Fois}
									paymentType={allowedPaymentType}
									onChange={onChange}
									ideal={ideal}
									onCreditCardInputsBlur={onCreditCardInputsBlur}
									onAdyenComponentMounted={onAdyenComponentMounted}
									onCreditCardSubmit={onCreditCardSubmit}
									onAdyenAdditionalDetails={onAdyenAdditionalDetails}
								/>
							</div>
						);
					})}
				</div>
			</div>
		);
	} else if (allowedPaymentTypes.length === 1) {
		if (allowedPaymentTypes[0].terms === PAYMENT_TERMS["1x"]) {
			let isAdyenFlow;
			if (allowedPaymentTypes[0].paymentType === PAYMENT_METHODS.ADYEN_FLOW) {
				isAdyenFlow = true;
			} else if (allowedPaymentTypes[0].paymentType === PAYMENT_METHODS.CARD) {
				isAdyenFlow = false;
			}
			return (
				<div className="payment-methods-fieldset-new payment-methods-fieldset-new--single">
					<CreditCardPaymentType
						payNowAmount={total}
						isAdyenFlow={isAdyenFlow}
						onAdyenComponentMounted={onAdyenComponentMounted}
						onCreditCardSubmit={onCreditCardSubmit}
						onAdyenAdditionalDetails={onAdyenAdditionalDetails}
						onCreditCardInputsBlur={onCreditCardInputsBlur}
					/>
				</div>
			);
		} else if (allowedPaymentTypes[0].terms === PAYMENT_TERMS["2x"]) {
			let isAdyenFlow;
			if (allowedPaymentTypes[0].paymentType === PAYMENT_METHODS.ADYEN_FLOW) {
				isAdyenFlow = true;
			} else if (allowedPaymentTypes[0].paymentType === PAYMENT_METHODS.CARD) {
				isAdyenFlow = false;
			}
			return (
				<div className="payment-methods-fieldset-new payment-methods-fieldset-new--single">
					<CreditCardPaymentType
						payNowAmount={mensualite2Fois.payNowAmount}
						isAdyenFlow={isAdyenFlow}
						payLaterAmount={mensualite2Fois.payLaterAmount}
						dueDate={mensualite2Fois.dueDate}
						onAdyenComponentMounted={onAdyenComponentMounted}
						onCreditCardSubmit={onCreditCardSubmit}
						onAdyenAdditionalDetails={onAdyenAdditionalDetails}
						onCreditCardInputsBlur={onCreditCardInputsBlur}
					/>
				</div>
			);
		}
	}

	return false;
};

PaymentMethodsFieldsetNew.propTypes = {
	fields: PropTypes.object,
	onCreditCardInputsBlur: PropTypes.func,
	onCreditCardSubmit: PropTypes.func,
	onAdyenAdditionalDetails: PropTypes.func,
	onAdyenComponentMounted: PropTypes.func,
	onChange: PropTypes.func,
	allowedPaymentTypes: PropTypes.arrayOf(paymentTypeShape),
	total: PropTypes.number,
	mensualite2Fois: PropTypes.object,
	swissbilling: PropTypes.object,
	ideal: PropTypes.object,
};

export default PaymentMethodsFieldsetNew;
